"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.flattenObject = void 0;
function flattenObject(value, keyParts, flattenedObject) {
    if (keyParts === void 0) { keyParts = []; }
    if (flattenedObject === void 0) { flattenedObject = {}; }
    if (typeof value === 'object') {
        for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
            var key = _a[_i];
            var subValue = value[key];
            var newKeyParts = __spreadArrays(keyParts, [key]);
            if (typeof subValue !== 'object') {
                flattenedObject[newKeyParts.join('.')] = subValue;
            }
            else {
                flattenObject(subValue, newKeyParts, flattenedObject);
            }
        }
    }
    return flattenedObject;
}
exports.flattenObject = flattenObject;
//# sourceMappingURL=utils.js.map